import React, { useEffect, useState } from "react";
import {
  Navbar,
  Footer,
  HeroSection,
  AboutSection,
  ProblemsSection,
  ScheduleSection,
  PrizesSection,
  ParticipationSection,
  LocationSection,
  PartnersSection,
} from "../component";
import { DatasetsSection } from "../component/Section/DatasetsSection";

export const Home = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("home");

  const hackathonDate = React.useMemo(() => new Date("2026-04-11T10:00:00"), []);

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = hackathonDate.getTime() - now;

      if (distance > 0) {
        setTimeLeft({
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor(
            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          ),
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((distance % (1000 * 60)) / 1000),
        });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [hackathonDate]);

  useEffect(() => {
    const handleScroll = () => {
      const sections = [
        "home",
        "about",
        "categories",
        "timeline",
        "prizes",
        "rules",
        "faq",
        "location",
        "sponsors",
      ];
      const current = sections.find((section) => {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          return rect.top <= 100 && rect.bottom >= 100;
        }
        return false;
      });
      if (current) setActiveSection(current);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setMobileMenuOpen(false);
    }
  };

  const navbar = [
    { label: "Hakkında", section: "about" },
    { label: "Kategoriler", section: "categories" },
    { label: "Takvim", section: "timeline" },
    { label: "Ödüller", section: "prizes" },
    { label: "Kurallar", section: "rules" },
    { label: "SSS", section: "faq" },
    { label: "Konum", section: "location" },
    { label: "İş Birlikleri", section: "sponsors" },
  ];

  return (
    <div className="min-h-screen bg-[var(--bg-primary)]">
      <Navbar
        navbar={navbar}
        activeSection={activeSection}
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
        scrollToSection={scrollToSection}
      />

      <HeroSection timeLeft={timeLeft} />
      <AboutSection />
      <ProblemsSection />
      <ScheduleSection />
      <PrizesSection />
      <ParticipationSection />
      <DatasetsSection />
      <LocationSection />
      <PartnersSection />
      <Footer />
    </div>
  );
};
